module.exports = __webpack_public_path__ + "img/latest-stories.4e709bde.png";